module.exports = __webpack_public_path__ + "img/contenuto_video.5279f26c.svg";